import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Gallery = class Gallery extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-gallery';
	}
	
	constructor(element) {
		super(element);
	}
	
	setVars() {
		this.$mediaFrame = this.$element.find('.media-frame');
		this.$thumbnailBtns = this.$element.find('.media-carousel__thumbnail-button');
		this.activeSlide = null;
		this.$allAssets = this.$element.find('.media-carousel__asset');
		this.activeThumbnailClass = 'active';
	}
	
	addEventListeners() {
		this.$thumbnailBtns.on('click', this.handleThumbnailBtnClick.bind(this));
	}
	
	render() {
		this.setVars();
		this.addEventListeners();
		this.initiateSnappyTracker();
		this.initiateGallery();
	}
	
	initiateSnappyTracker() {
		this.SnappyComponents = [];
	}
	
	handleThumbnailBtnClick(event) {
		const $thumbnail = $(event.currentTarget);
		this.setActiveSlide($thumbnail);
	}
	
	initiateGallery() {
		const $firstThumnail = this.$element.find('.carousel__slide[data-slick-index="0"] .media-carousel__thumbnail-button[data-asset="0"]');
		this.setActiveSlide($firstThumnail);
	}
	
	setActiveSlide($thumbnail) {
		const $asset = $thumbnail.siblings('.media-carousel__asset');
		const slickIndex = $thumbnail.parents('.slick-slide').data('slick-index');
		
		if (slickIndex !== this.slickIndex) {
			this.emptyFrame();
			this.setActiveClasses($thumbnail);
			this.injectViewIntoFrame($asset);
			this.activeSlide = slickIndex;
		}
	}
	
	setActiveClasses($thumbnail) {
		this.$thumbnailBtns.removeClass(this.activeThumbnailClass);
		$thumbnail.addClass(this.activeThumbnailClass);
	}
	
	injectViewIntoFrame($asset) {
		const $clone = $asset.clone();
		const $pageMedia = $clone.find('.fa-page-media');
		this.$mediaFrame.append($clone);
		this.activeFrame = new Snappy.Component.PageMedia($pageMedia[0]);
		this.activeFrame.render();
		this.SnappyComponents.push(this.activeFrame);
	}
	
	emptyFrame() {
		this.SnappyComponents = [];
		this.$mediaFrame.empty();
	}
};



// WEBPACK FOOTER //
// ./components/gallery/scripts/gallery.js